// extracted by mini-css-extract-plugin
export default {"cookieBanner":"COixHk8CfI8EFwRvm_Kb","cookieBannerModalCont":"AMtW9KRG9cdis18HTlq6","cookieBannerModal":"omTiFI2oZ50XGtCcWPP5","cookieBannerModalBtn":"QdQK7EctMU6RJWbZfyE0"};